import moment from 'moment'
import * as organizationApi from '../../../api/fuel_request/organization'
import * as router from '../../../constants/router'
import * as constants from '../../../constants'
import * as common from '../common'
import * as field from '../field'

export const operatorFuelRequestOrganizationHistoryAction = () => async (dispatch, getState) => {
    let currentState = getState()
    let vOperatorMobileNumber = currentState.config.mobile
    let result = await organizationApi.operatorFuelRequestOrganizationHistory({ vOperatorMobileNumber, vType: 'new' })
    if (result.status) dispatch(field.setFields([
        { data: result.data[0].list, field: 'list' },
        { data: result.data[0].details, field: 'details' }
    ]))
}

export const operatorDuelRequestOrganizationInprocessAction = () => async (dispatch, getState) => {
    let currentState = getState()
    let vOperatorMobileNumber = currentState.config.mobile
    let result = await organizationApi.operatorDuelRequestOrganizationInprocess({ vOperatorMobileNumber })
    if (result.status) dispatch(field.setFields([{ data: result.data, field: 'list' }]))
}

export const fuelRequestOrganizationByRequestCodeAction = (vRequestCode) => async (dispatch) => {
    dispatch(common.loadingPageAction(true))
    let result = await organizationApi.fuelRequestOrganizationByRequestCode({ vRequestCode, iPersonType: constants.PERSON_TYPE })
    if (result.status) dispatch(field.setFields([{ data: result.data, field: 'list' }]))
    else dispatch(common.redirectAction(router.HOME))
    dispatch(common.loadingPageAction(false))
}

export const fuelRequestOrganizationVolumeReceivedAction = (vRequestCode) => async (dispatch, getState) => {
    let state = getState().field
    let data = {
        vRequestCode,
        iVolume: state.litrage,
    }
    dispatch(common.loadingBtnAction(true))
    let result = await organizationApi.fuelRequestOrganizationVolumeReceived(data)
    if (result.status) {
        dispatch(common.snackbarAction(true, result.message))
        dispatch(fuelRequestOrganizationByRequestCodeAction(vRequestCode))
    }
    dispatch(common.loadingBtnAction(false))
}

export const completeRequestOrganizationAction = (vRequestCode) => async (dispatch, getState) => {
    let state = getState().field
    let data = {
        vRequestCode,
        tEndTime: moment(state.endTime).format('HH:mm'),
        tStartTime: moment(state.startTime).format('HH:mm'),
        iReceivedPrice: state.amount
    }
    dispatch(common.loadingBtnAction(true))
    let result = await organizationApi.completeRequestOrganization(data)
    if (result.status) {
        dispatch(common.snackbarAction(true, result.message))
        dispatch(field.setFields([
            { data: 0, field: 'amount' },
            { data: 0, field: 'litrage' }
        ]))
        dispatch(common.redirectAction(router.HOME))
    }
    dispatch(common.loadingBtnAction(false))
}